import { Feature } from "util/stdtypes";
import { NotificationConfig } from "./account-notification-permission";

export const AccountEmailNotificationPermissionFeature: Feature<NotificationConfig, {}> = {
    name: "Email Notification Permission",
    key: "emailnotificationpermission",
    parentFeature: 'notificationpermission',
    providesConfig: {
        emailNotificationPermissions: true
    }
}

export const AccountEmailNotifReplyFeature: Feature<NotificationConfig, {}> = {
    name: "Email Notification Replies",
    key: "emailnotificationreplies",
    parentFeature: "emailnotificationpermission",
    providesConfig: {
        emailReplyNotificationToggleEnabled: true
    }
}

export const AccountEmailNotifModFeature: Feature<NotificationConfig, {}> = {
    name: "Email Notification Moderation",
    key: "emailnotificationmoderation",
    parentFeature: "emailnotificationpermission",
    providesConfig: {
        emailModNotificationToggleEnabled: true
    }
}